import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgSmallWarning = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 16, height: 13, viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M0.666748 13H15.3334L8.00008 0.333374L0.666748 13ZM8.66675 11H7.33341V9.66671H8.66675V11ZM8.66675 8.33337H7.33341V5.66671H8.66675V8.33337Z", fill: "white" }) });
const ForwardRef = forwardRef(SvgSmallWarning);
export { ForwardRef as ReactComponent };
